import { useSelector } from "react-redux";
import { selectIsPending } from "../redux/reducer/app-slice";

export const useIsPending = (requestName) =>
  useSelector((state) => selectIsPending(state, requestName));
